import {
    AnyAction,
    Middleware,
    MiddlewareAPI,
    ThunkDispatch,
} from '@reduxjs/toolkit'
import {
    NinchatActions,
    NinchatEvents,
} from '../api/types'
import {
    sendFile,
    updateFileUpload,
} from '../state/ui'
import {AttachmentFile} from '../types/ui'
import {NinchatAccessCreatedEvent} from 'api/types/events'
import {NinchatActionType} from '../api/types/actions'
import {RootState} from '../store'
import {call} from '../actions/ninchat/client'
import {createAccess} from 'api/action/createAccess'

type AsyncThunkDispatch = ThunkDispatch<RootState, undefined, AnyAction>

export const uiMiddleware: Middleware = (store: MiddlewareAPI<AsyncThunkDispatch>) => (next) => (action) => {
    const {dispatch} = store

    switch (action.type) {
        case sendFile.type: {
            const result = next(action)

            const {
                actionType,
                chat,
                files,
            } = action.payload

            const chat_id = chat.channel_id ?? chat.user_id

            files.forEach(async (file: AttachmentFile) => {
                try {
                    const access = await dispatch(createAccess({access_type: 'session'})).unwrap() as NinchatAccessCreatedEvent

                    const caller = {caller_access_key: access?.access_key}

                    const message = await dispatch(call({
                        header: {
                            action: actionType ?? NinchatActionType.NinchatSendFileAction,
                            ...chat,
                            file_attrs: {name: file.name},
                        } as NinchatActions.NinchatSendFileAction,
                        meta: {
                            caller,
                            xhr: {
                                method: 'POST',
                                type: 'application/octet-stream',
                            },
                        },
                        payload: file,
                    })) as unknown as NinchatEvents.NinchatMessageReceivedEvent[] | NinchatEvents.NinchatErrorEvent[] | NinchatEvents.NinchatFileUploadedEvent[]

                    if (message[0].event === 'error') {
                        dispatch(updateFileUpload({
                            chat_id,
                            data: {error: message[0]},
                            filename: file.name,
                        }))
                    }
                } catch (error) {
                    dispatch(updateFileUpload({
                        chat_id,
                        data: {
                            error: error instanceof Error
                                ? {error_reason: error.message} as NinchatEvents.NinchatErrorEvent
                                : error as NinchatEvents.NinchatErrorEvent,
                        },
                        filename: file.name,
                    }))
                }
            })

            return result
        }
        default:
            return next(action)
    }
}
